import { Button, Drawer, Layout, Menu } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppContext } from '@/context/appContext';
import { selectAuth } from '@/redux/auth/selectors';
import logoText from '@/style/images/logo.png';
import logoIcon from '@/style/images/logo.png';
import history from '@/utils/history';
import { useSelector } from 'react-redux';
import { RESOURCE_LOCAL_STORAGE } from '@/constants/localStorageKeyConstants';
import { getIconComponent } from '@/utils/iconUtils';
import { MenuOutlined, SettingOutlined, ApartmentOutlined } from '@ant-design/icons';
const { Sider } = Layout;
const { SubMenu } = Menu;

export default function Navigation({
  resourceResult
}) {
  return (
    <>
      <div className="sidebar-wraper">
        <Sidebar collapsible={true} resourceResult={resourceResult} />
      </div>
      <MobileSidebar resourceResult={resourceResult} />
    </>
  );
}

function Sidebar({ collapsible, resourceResult }) {
  let location = useLocation();
  const { state: stateApp, appContextAction } = useAppContext();
  const { isNavMenuClose } = stateApp;
  const { navMenu } = appContextAction;
  const [showLogoApp, setLogoApp] = useState(isNavMenuClose);
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    if (location) if (currentPath !== location.pathname) setCurrentPath(location.pathname);
  }, [location, currentPath]);

  useEffect(() => {
    if (isNavMenuClose) {
      setLogoApp(isNavMenuClose);
    }
    const timer = setTimeout(() => {
      if (!isNavMenuClose) {
        setLogoApp(isNavMenuClose);
      }
    }, 200);
    return () => clearTimeout(timer);
  }, [isNavMenuClose]);

  const onCollapse = () => {
    navMenu.collapse();
  };

  // Decrypt the resources from localStorage
  const currentUser = useSelector(selectAuth);

  // Arrays to hold the menu items
  const MY_SIDEBAR_MENU = [];
  const MY_SETTINGS_SUBMENU = [];
  const MY_STRUCTURE_SUBMENU = [];
  if (resourceResult && currentUser && currentUser.role) {
    for (const resourceItem of currentUser?.role?.resources) {
      const resourceDetails = resourceResult.find(
        (resource) => resource._id === resourceItem.resource
      );

      if (resourceDetails) {
        if (resourceDetails.isSubMenu) {
          if (resourceDetails.parentMenu === 'Settings') {
            MY_SETTINGS_SUBMENU.push({
              url: resourceDetails.url,
              name: resourceDetails.name,
              isSubMenu: resourceDetails.isSubMenu,
            });
          }
          if (resourceDetails.parentMenu === 'Structure') {
            MY_STRUCTURE_SUBMENU.push({
              url: resourceDetails.url,
              name: resourceDetails.name,
              isSubMenu: resourceDetails.isSubMenu,
            });
          }
        } else {
          MY_SIDEBAR_MENU.push({
            url: resourceDetails.url,
            name: resourceDetails.name,
            isSubMenu: resourceDetails.isSubMenu,
          });
        }
      }
    }
  }

  return (
    <>
      <Sider
        collapsible={collapsible}
        collapsed={collapsible ? isNavMenuClose : collapsible}
        onCollapse={onCollapse}
        className="navigation"
      >
        <div className="logo" onClick={() => history.push('/')} style={{ cursor: 'pointer' }}>
          <div className="h-56 grid grid-cols-3 gap-1 content-stretch">
            <img src={logoIcon} alt="Logo" style={{ height: '32px', borderRadius: '50%' }} />

            {!showLogoApp && <img src={logoText} alt="Logo" style={{ height: '29px' }} />}
          </div>
        </div>
        <Menu mode="inline" selectedKeys={[currentPath]}>
          {/* Display all Sidebar Menu Items without slice limit */}
          {MY_SIDEBAR_MENU.map((menuItem) => (
            <Menu.Item key={menuItem.url} icon={getIconComponent(menuItem.name)}>
              <Link to={menuItem.url} />
              {menuItem.name}
            </Menu.Item>
          ))}

          {/* Display Submenus for Structure */}
          {MY_STRUCTURE_SUBMENU.length > 0 && (
            <SubMenu key={'Structure'} icon={<ApartmentOutlined />} title={'Org Structures'}>
              {MY_STRUCTURE_SUBMENU.map((menuItem) => (
                <Menu.Item key={menuItem.url} icon={getIconComponent(menuItem.name)}>
                  <Link to={menuItem.url} />
                  {menuItem.name}
                </Menu.Item>
              ))}
            </SubMenu>
          )}

          {/* Display Submenus for Settings */}
          {MY_SETTINGS_SUBMENU.length > 0 && (
            <SubMenu key={'Settings'} icon={<SettingOutlined />} title={'Settings'}>
              {MY_SETTINGS_SUBMENU.map((menuItem) => (
                <Menu.Item key={menuItem.url} icon={getIconComponent(menuItem.name)}>
                  <Link to={menuItem.url} />
                  {menuItem.name}
                </Menu.Item>
              ))}
            </SubMenu>
          )}
        </Menu>
      </Sider>
    </>
  );
}

function MobileSidebar({ resourceResult }) {
  const [visible, setVisible] = useState(false);
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  return (
    <>
      <Button type="text" size="large" onClick={showDrawer} className="mobile-sidebar-btn">
        <MenuOutlined />
      </Button>
      <Drawer
        width={200}
        placement="left"
        closable={false}
        onClose={onClose}
        visible={visible}
        className="mobile-sidebar-wraper"
        bodyStyle={{ backgroundColor: '#253271', color: 'white' }}
      >
        <Sidebar collapsible={false} resourceResult={resourceResult} />
      </Drawer>
    </>
  );
}
